import React, { ComponentPropsWithoutRef, ComponentRef, forwardRef } from "react"

import * as styles from "./link-button.styled"

type LinkButtonProps = ComponentPropsWithoutRef<"button"> & {
  RightIcon?: React.ReactNode
  LeftIcon?: React.ReactNode
}

export const LinkButton = forwardRef<ComponentRef<"button">, LinkButtonProps>(
  ({ RightIcon, LeftIcon, className, children, ...rest }, ref) => {
    return (
      <button {...rest} className={styles.button(className)} ref={ref}>
        {LeftIcon}
        <span className={styles.buttonText}>{children}</span>
        {RightIcon}
      </button>
    )
  },
)

LinkButton.displayName = "LinkButton"
